<template>
    <div id="app">
        <page-header></page-header>
        <router-view v-if="initialized"></router-view>
        <div class="container" v-else>
            <b-alert variant="warning" show>
                <i class="fa fa-refresh fa-spin fa-2x"></i> <span class="h3">{{ $t('WAITING_FOR_SERVER') }}</span>
            </b-alert>
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import pageFooter from './components/Footer.vue';
import pageHeader from './components/Header.vue';
import { mapGetters } from 'vuex';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/less/jtl.less';
import './fonts/font-awesome-extension/font-awesome-extension.css';
import 'font-awesome/css/font-awesome.css';

export default {
    name:       'app',
    components: { pageFooter, pageHeader },
    computed:   mapGetters({
        initialized: 'initialization'
    })
};
</script>

<style lang="less">
body, body .btn {
    font-family: Arial,Helvetica,sans-serif;
}
body {
    touch-action: manipulation;
    min-width: 320px;
}
h1, h2, h3, h4, .navbar-brand, body h1, body h2, body h3, body h4, body .navbar-brand {
    font-family: 'Raleway', 'Museo', Georgia, 'DejaVu Sans', Arial, Verdana, Helvetica, sans-serif;
}
h3, .h3, .card-header h3, .card-header .h3 {
    font-size: 1.2rem;
}
.card-header h2, .card-header h3, .card-header h4 {
    margin-bottom: 0;
}
#app .container {
    padding-left: 10px;
    padding-right: 10px;
}
.btn.disabled, .btn:disabled {
    cursor: default;
    opacity: 0.5;
    &:hover {
        box-shadow: none;
    }
}

.icon {
    max-width: 100%;
    min-height: 60px;
}
i.achievement-font-icon, i.shop-font-icon, i.upgrade-font-icon {
    font-size: 6.6em;
    font-size: 6.6vw;
    color: #b31243;
}
@media (max-width: 576px) {
    i.achievement-font-icon, i.shop-font-icon, i.upgrade-font-icon {
        font-size: 6.6em;
        max-height: 100%;
    }
}

.show > .btn-secondary.dropdown-toggle {
    background-color: #fff;
    color: #ccc;
}

.input-group, .form-group {
    label {
        cursor: pointer;
        margin: 0;
    }
}
.input-group-cstm > .form-control, .input-group-cstm > .custom-select, .input-group-cstm > .input-group-prepend > .input-group-text, .input-group-cstm > .input-group-append > .input-group-text, .input-group-cstm > .input-group-prepend > .btn, .input-group-cstm > .input-group-append > .btn {
    font-size: 1.0rem!important;
}
.pagination {
    .disabled a {
        cursor: default;
    }
    li {
        padding: 0.5rem 0;
        cursor: pointer;
        &:hover {
            color: #000;
        }
        a {
            display: block;
            padding: 0;
            height: 100%;
            width: 100%;
            cursor: pointer;
        }
    }
    .btn-secondary {
        color: #292b2c;
        background-color: #fff;
        border-color: #ccc;
        &:hover {
            background-color: #fff;
        }
    }
    .btn-secondary.disabled {
         background-color: #fff;
         border-color: #ccc;
     }
    .btn-secondary:not([disabled]):not(.disabled):active,
    .btn-secondary:not([disabled]):not(.disabled).active {
        background-color: #fff;
        color: #ccc;
    }
}
</style>
